import RcsUtils from '../utils/RcsUtils';

class MdBxBottom {
  render() {
    let sectionRow = Array.from(document.querySelectorAll('.md_bx_bottom'));
    if (sectionRow && sectionRow.length) {
      let firstSectionRow = sectionRow[0];
      RcsUtils.addClass(firstSectionRow, 'firstRow');
      let artRow = Array.from(document.querySelectorAll('.firstRow .bk_art_021'));
      let i = 1;
      artRow.forEach(element => {
        if (i > 1) {
          RcsUtils.addClass(element, 'allRow');
        }
        i++;
      });
    }
  }
}

module.exports = MdBxBottom;



// WEBPACK FOOTER //
// ./src/rcs_cor_hp-lazy-loading/boxes/MdBxBottom.js